

module.exports = __webpack_require__.stylable.create(
    "PaypalButton3698600145",
    {"classes":{"root":"PaypalButton3698600145__root","paypalButton":"PaypalButton3698600145__paypalButton","paypalButtonLabel":"PaypalButton3698600145__paypalButtonLabel"},"vars":{},"stVars":{"paypalButtonBorderRadius":"'\"fallback(font(--cartButton_cornersRadius), 0)\"'","paypalButtonBackground":"rgb(255, 196, 56)","paypalButtonTextColor":"#333","paypalButtonTextFont":"'normal normal normal 11px/1 HelveticaNeueW01-65Medi, HelveticaNeueW02-65Medi, HelveticaNeueW10-65Medi, Helvetica Neue, Helvetica, Arial, メイリオ, meiryo, ヒラギノ角ゴ pro w3, hiragino kaku gothic pro, sans-serif'","paypalButtonHoverBorderColor":"rgba(255, 196, 56, 0.8)"},"keyframes":{}},
    "",
    8,
    "PaypalButton3698600145",
    null
);
